module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildingVerificate"
    }
  }, [_c('div', {
    staticClass: "headLine"
  }, [_vm._v("产业空间信息审核")]), _vm._v(" "), _c('div', {
    staticClass: "navLine"
  }, _vm._l((_vm.navArr), function(item, inx) {
    return _c('div', {
      class: ['navItem', {
        'act': _vm.navAct == inx
      }],
      on: {
        "click": function($event) {
          _vm.navChange(inx)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "border": "",
      "header-cell-class-name": "dHead",
      "data": _vm.tbData
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "align": "center",
      "width": "60",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                 " + _vm._s(scope.$index + (_vm.params.no - 1) * _vm.params.size + 1) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buildingName",
      "fixed": "left",
      "align": "center",
      "min-width": "150",
      "label": "楼宇名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tenement",
      "align": "center",
      "width": "120",
      "label": "物业单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "propertyUnit",
      "align": "center",
      "min-width": "120",
      "label": "产权单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jiexiang",
      "align": "center",
      "width": "90",
      "label": "所在街乡"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "propertyUnit",
      "align": "center",
      "min-width": "150",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "park",
      "align": "center",
      "width": "150",
      "label": "所属功能区"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectType",
      "align": "center",
      "width": "120",
      "label": "项目类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nationalized",
      "align": "center",
      "width": "120",
      "label": "是否国有"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "location",
      "align": "center",
      "width": "120",
      "label": "产业定位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isWillingCityPlatformReleaseRecommend",
      "align": "center",
      "width": "150",
      "label": "是否愿意在市级平台对外发布推介"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isWillingDistrictInvestmentWorkeleaseRecommend",
      "align": "center",
      "width": "120",
      "label": "是否愿意在区级招商工作中对外发布推介"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "notPublishReason",
      "align": "center",
      "width": "120",
      "label": "不希望对外发布的原因"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isWillingUndertakeInterOrganizationWorkspace",
      "align": "center",
      "width": "120",
      "label": "是否愿意承接国际组织办公场所"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planBuildingArea",
      "align": "center",
      "width": "120",
      "label": "规划建筑面积(平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalVacantArea",
      "align": "center",
      "width": "150",
      "label": "当前空置可招商面积(平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leadingCadre",
      "align": "center",
      "width": "120",
      "label": "招商负责人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leadingCadrePhone",
      "align": "center",
      "width": "150",
      "label": "负责人手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leadingCadreEmail",
      "align": "center",
      "width": "120",
      "label": "负责人邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uploadUser",
      "align": "center",
      "width": "90",
      "label": "上传用户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "align": "center",
      "width": "180",
      "label": "上传时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "prop": "status",
      "align": "center",
      "width": "90",
      "label": "状态",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                       " + _vm._s(_vm._f("statusTrans")(scope.row.status)) + "\n                   ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "90",
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('span', {
          staticClass: "ibtn",
          on: {
            "click": function($event) {
              _vm.goInner(scope.row.id, 1)
            }
          }
        }, [_vm._v("查看")]) : (scope.row.status == 1) ? _c('span', {
          staticClass: "ibtn",
          on: {
            "click": function($event) {
              _vm.goInner(scope.row.id, 2)
            }
          }
        }, [_vm._v("审核")]) : _c('span', [_vm._v("-")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-footer"
  }, [(_vm.allPages > 1) ? _c('el-pagination', {
    staticClass: "paging",
    attrs: {
      "current-page": _vm.params.no,
      "page-size": _vm.params.size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.params.allEls
    },
    on: {
      "current-change": _vm.pageChange
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5c28da26"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingVerificate/index.vue
// module id = 1501
// module chunks = 1